a.inventory = (function(){
	var my = {
		change:{
			popup:function(type,o){
				var types = ['add','subtract','adjust'];
				var names = ['Add','Pick','Adjust'];
				if (a.s.ac.allow('action','inventory') && types.indexOf(type) !== -1) {
					var s = o || {};
					var f_close = s.close || function(){};
					var title = s.title || names[types.indexOf(type)]+' inventory';
					var iid = s.iid || undefined;
					// Create popup
					var token = a.popup.create({
						slideFrom:'fromleft',
						title:title,
						close:function(){
							f_close();
						},
						ready:function(token){
							var win = $('#popupid_'+token);
							tpl.run({
								tpl:'/tpl/inventory/change/'+type+'.ejs?v='+v,
								data:{iid:iid},
								cb:function(c){
									$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
										// Focus amount
										$('input[name="amount"]',win).focus();
										// Bind save
										$('button[data-action="save"]',win).unbind('click').click(function(){
											my.change.save(type,iid,win,f_close);
										});
									});
								}
							});
						}
					});
				}
				else {
					a.s.growl.create('Access denied','You have no access to this function',{});
				}
			},
			save:function(type,iid,win,cb){
				var form = $('form',win);
				$.ajax({
					type:'POST',
					url:'/api/item/inventory/'+type+'/',
					data:{
						iid:iid,
						amount:$('input[name="amount"]',form).val(),
						remarks:$('textarea[name="remarks"]',form).val(),
						token:localStorage.getItem('token'),
						accountname:localStorage.getItem('accountname')
					},
					dataType:'json',
					cache: false,
					success:function(result) {
						if (result.success) {
							a.s.growl.create('Saved','Inventory change has been saved',{'duration':5000});
							window.history.back();
						}
						else {
							a.s.growl.create('Error','The inventory change could not be saved',{'duration':5000});
						}
						cb();
					}
				});
			}
		}
	}
	return my;
}());